import { render, staticRenderFns } from "./studyRecord.vue?vue&type=template&id=466fd54b&scoped=true"
import script from "./studyRecord.vue?vue&type=script&lang=js"
export * from "./studyRecord.vue?vue&type=script&lang=js"
import style0 from "./studyRecord.vue?vue&type=style&index=0&id=466fd54b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "466fd54b",
  null
  
)

export default component.exports